<app-page-header title="Notices" [breadcrumbs]="breadcrumb"></app-page-header>

<section class="content">
    <div class="container-fluid">
      <div class="col-lg-12">
        <mat-card class="stats">
          <mat-card-header
            class="loading-header"
            [ngClass]="{ loading: loading }"
          >
            <mat-progress-bar
              mode="indeterminate"
              *ngIf="loading"
            ></mat-progress-bar>
          </mat-card-header>
          <div class="title">
            <h3>Stats (mois courant)</h3>
            <button mat-mini-fab color="primary" (click)="getStats()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
          <pre>{{ statsResponse | json }}</pre>
        </mat-card>
      </div>
    </div>
  </section>